<template>
  <div>
    <h1>Login</h1>
    <form class="w-25 ml-auto mr-auto text-left" @submit.prevent="login()">
      <div class="form-group">
        <!-- <label for="usernameInput">Username</label> -->
        <input
          id="usernameInput"
          v-model="username"
          type="text"
          class="form-control"
          placeholder="Username"
        />
        <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
      </div>
      <div class="form-group">
        <!-- <label for="passwordInput">Password</label> -->
        <input
          id="passwordInput"
          v-model="password"
          type="password"
          class="form-control"
          placeholder="Password"
        />
      </div>
      <!-- <div class="form-group form-check">
                <input type="checkbox" class="form-check-input" id="exampleCheck1">
                <label class="form-check-label" for="exampleCheck1">Check me out</label>
            </div> -->
      <button type="submit" class="btn btn-primary">Submit</button>
    </form>
    <!-- <button class="btn btn-danger" @click="logout()">Logout</button> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      username: null,
      password: null
    }
  },
  computed: mapState(['auth', 'refererRouteLogin']),
  beforeMount() {
    if (this.$auth.isAuthenticated() === true) {
      this.$router.push({ path: '/' })
    }
  },
  methods: {
    ...mapMutations(['setUserLoggedIn']),
    login() {
      let user = {
        username: this.username,
        password: this.password
      }
            this.$store
                .dispatch('login', user)
                .then(() => {
                    // console.log('response:', response, 'refererRouteLogin: ', this.$route)
                    // const redirectTo = localStorage.getItem('refererLogin')
                    // this.setUserLoggedIn(user.username)
                    // this.$router.push({ name: this.refererRouteLogin })
                    this.$router.push('/home')
                })
                .catch(error => {
                    this.$swal({
                        type: 'error',
                        title: 'Oops...',
                        text: error.response.data.message
                        // footer: '<a href>Why do I have this issue?</a>'
                    })
                })
        },
        logout() {
            // this.$auth.logout()
            this.$store.commit('logout')
        }

    /* register: function() {
            this.$auth.register({ name, email, password }).then(() => {

            })
        } */
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/users/LoginPage.vue